import { createSlice } from '@reduxjs/toolkit';
import { $authHost } from '../../http';

export const fetchTasks = (token) => async (dispatch, getState) => {
    try {
        // dispatch(setLoading());

        $authHost.get('/apig/tasks', {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(res => {
            const { data } = res.data;
            console.log('Данные с сервера:', data);
            
            // Проверяем, есть ли несинхронизированные данные
            const { tasksQueue } = getState().tasks;
            
            if (tasksQueue.length > 0) {
                console.log('Игнорируем данные с сервера - есть локальные изменения в очереди');
                return;
            }
            
            dispatch(setTasks(data));
        }).catch(err => {
            // throw new Error(err)
            dispatch(setError(err.message));
        })

    } catch (err) {
        dispatch(setError(err.message));
    }
};


const tasksSlice = createSlice({
    name: 'tasks',
    initialState: {
        tasks: [],
        tasksQueue: localStorage.getItem('tasksQueue') ? JSON.parse(localStorage.getItem('tasksQueue')) : [],
        pointsTasks: null,
        error: null,
    },
    reducers: {
        setTasks(state, action) {
            state.tasks = action.payload;
        },
        addTask(state, action) {
            console.log('addTask', action.payload)
            state.tasks.push(action.payload);
        },
        updateTask(state, action) {
            console.log('updateTask', action.payload)
            const { id, ...updatedTask } = action.payload;
            const taskIndex = state.tasks.findIndex(task => task.id === id);
            if (taskIndex !== -1) {
                state.tasks[taskIndex] = { ...state.tasks[taskIndex], ...updatedTask, id };
            }
        },
        updateTaskId(state, action) {
            console.log('updateTaskId', action.payload)
            const {oldTaskId, newTaskId} = action.payload;
            const taskIndex = state.tasks.findIndex(task => task.id === oldTaskId);
            if (taskIndex !== -1) {
                state.tasks[taskIndex].id = newTaskId;
            }
        },

        deleteTask(state, action) {
            console.log('deleteTask', action.payload)
            const id = action.payload;
            console.log(id, state.tasks)
            const taskIndex = state.tasks.findIndex(task => task.id === id);
            console.log('taskIndex', taskIndex)
            if (taskIndex !== -1) {
                state.tasks.splice(taskIndex, 1);
            }
        },
        addTaskToQueue(state, action) {
            console.log('addTaskToQueue', action.payload)
            state.tasksQueue.filter(item => item.task.id !== action.payload.task.id);
            state.tasksQueue.push(action.payload);
            localStorage.setItem('tasksQueue', JSON.stringify(state.tasksQueue));
        },
        removeFromQueue(state, action) {
            console.log('removeFromQueue', action.payload)
            const itemToRemove = action.payload;
            state.tasksQueue = state.tasksQueue.filter(item => 
                !(item.timestamp === itemToRemove.timestamp && 
                  item.action === itemToRemove.action &&
                  item.task.id === itemToRemove.task.id)
            );
            localStorage.setItem('tasksQueue', JSON.stringify(state.tasksQueue));
        },
        clearQueue(state) {
            console.log('clearQueue')
            state.tasksQueue = [];
            localStorage.removeItem('tasksQueue');
        },
        setError(state, action) {
            state.error = action.payload;
        },
        setPointsTasks(state, action) {
            state.pointsTasks = action.payload;
        }
    }
});


export const { setTasks, addTask, updateTask, updateTaskId, deleteTask, setError, addTaskToQueue, removeFromQueue, clearQueue, setPointsTasks } = tasksSlice.actions;

export const fetchPointsTasks = (statuses = []) => async (dispatch, getState) => {
    try {
        const { data } = await $authHost.get('/apig/tasks/points', {
            params: statuses.length > 0 ? { statuses: Array.isArray(statuses) ? statuses.join(',') : statuses } : {}
        });
        if (data.success) {
            dispatch(setPointsTasks(data.data));
        }
    } catch (err) {
        console.error('Error fetching points tasks:', err);
        dispatch(setError(err.message));
    }
};

export default tasksSlice.reducer;